import { FC, memo, PropsWithChildren } from 'react';

import { Logo } from '@components/icons';
import { StyledAppBar, StyledWrapperContent, Container } from './styled';

const RegistrationView: FC<PropsWithChildren> = ({ children }) => (
  <>
    <StyledAppBar>
      <Container>
        <Logo />
      </Container>
    </StyledAppBar>
    <StyledWrapperContent>
      <Container>{children}</Container>
    </StyledWrapperContent>
  </>
);

export default memo(RegistrationView);
